import script from "./DomainModelSystemRow.vue?vue&type=script&setup=true&lang=js"
export * from "./DomainModelSystemRow.vue?vue&type=script&setup=true&lang=js"

import "./DomainModelSystemRow.vue?vue&type=style&index=0&id=c1d1dc42&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1d1dc42"]])

export default __exports__